import { render, staticRenderFns } from "./TaesungCenterPage.vue?vue&type=template&id=12fbb579&scoped=true"
import script from "./TaesungCenterPage.vue?vue&type=script&lang=js"
export * from "./TaesungCenterPage.vue?vue&type=script&lang=js"
import style0 from "./TaesungCenterPage.vue?vue&type=style&index=0&id=12fbb579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fbb579",
  null
  
)

export default component.exports